import { STATIC_MWEB_CART, MWEB_CART } from "@cart-client/constants/Paths";
import { getDownstreamHostsValue } from "@swiggy-private/checkout-core";

export const isStaticHTMLBuild = () => {
    const isStaticHTMLBuild = getDownstreamHostsValue("IS_STATIC_HTML_BUILD") || "false";
    return String(isStaticHTMLBuild) === "true";
};

export const getStaticMwebCartPath = () => {
    if (isStaticHTMLBuild()) {
        return STATIC_MWEB_CART;
    }
    return MWEB_CART;
};
